import { useState } from "react";
import { Grid, Box } from "@mui/material";
import HelpSidebar from "../../../../components/HelpSidebar";
import GettingStarted from "./faq/GettingStarted";
import TechnicalSupport from "./faq/TechnicalSupport";
import TransmittalRCE from "./faq/TransmittalRCE";
import ComingSoon from "../../../../../app/components/ComingSoon";

const FAQs = () => {
  const [tab, setTab] = useState("Getting Started");

    const sidebarItems = [
      { label: "Getting Started", subMenus: [], subKey: "" },
      { label: "Support & Help", subMenus: [], subKey: "" },
    ]

  const renderFaqDoc = (intent) => {
    switch (intent) {
      // case "Getting Started":
      //   return <GettingStarted />;
      case "Support & Help":
        return <TechnicalSupport />;
      case "RCE Transmittal":
        return <TransmittalRCE />
      default:
        return (
          <ComingSoon />
        );
    }
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{
        bgcolor: "#f5f8fc",
        py: 2,
        height: "100%",
        flex: 1,
        overflow: "hidden",
        minHeight: 0,
      }}
    >
      {/* Sidebar */}
      <Grid item xs={12} md={3} sx={{ height: "100%", minHeight: 0 }}>
        <Box
          sx={{
            bgcolor: "white",
            borderRadius: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            minHeight: 0,
          }}
        >

          <Box
            sx={{
              overflowY: "auto",
              flex: 1,
              minHeight: 0,
              "&::-webkit-scrollbar": { width: "6px" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(0,0,0,0.3)",
                borderRadius: "10px",
              },
              scrollbarWidth: "thin",
              scrollbarGutter: "stable",
            }}
          >
            <HelpSidebar sidebarItems={sidebarItems || []} tab={tab} setTab={setTab} />
          </Box>
        </Box>
      </Grid>

      {/* Content */}
      <Grid item xs={12} md={9} sx={{ height: "100%", minHeight: 0 }}>
        <Box
          sx={{
            bgcolor: "white",
            borderRadius: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            minHeight: 0,
          }}
        >
          <Box
            sx={{
              overflowY: "auto",
              flex: 1,
              minHeight: 0,
              "&::-webkit-scrollbar": { width: "6px" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(0,0,0,0.3)",
                borderRadius: "10px",
              },
              scrollbarWidth: "thin",
            }}
          >
            {renderFaqDoc(tab)}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default FAQs;
